import * as React from 'react'
import type { TextareaProps } from './Textarea.types'
import { cn } from '@core/utils'
import Icon from '../Icon/Icon'

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    (
        {
            label,
            labelLeftIcon,
            labelRightIcon,
            helperText,
            error,
            textareaClassName,
            className,
            containerProps,
            onBlur,
            ...props
        },
        ref,
    ) => {
        const [focused, setFocused] = React.useState<boolean>(false)

        return (
            <div
                data-error={error}
                data-focused={focused}
                data-disabled={props.disabled}
                className={cn('flex flex-col gap-2', className)}
                {...containerProps}>
                {label && (
                    <label
                        htmlFor={props.id}
                        className="flex items-center gap-2 fill-semantic-content-inkMedium text-semantic-content-inkMedium">
                        {labelLeftIcon && (
                            <Icon name={labelLeftIcon} size={16} />
                        )}
                        <span className="text-label-md">{label}</span>
                        {labelRightIcon && (
                            <Icon name={labelRightIcon} size={16} />
                        )}
                    </label>
                )}
                <textarea
                    data-error={error}
                    className={cn(
                        'flex min-h-[152px] w-full rounded-[13px] border-[1.6px] border-transparent bg-semantic-background-primary p-4 !text-body-lg-r text-semantic-content-ink placeholder:text-semantic-content-inkMedium focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[error=true]:border-semantic-content-error',
                        textareaClassName,
                    )}
                    ref={ref}
                    {...props}
                    onFocus={() => setFocused(true)}
                    onBlur={e => {
                        setFocused(false)
                        onBlur && onBlur(e)
                    }}
                />
                {helperText && (
                    <span className="form-input__helper">{helperText}</span>
                )}
            </div>
        )
    },
)

export default Textarea
